import { render, staticRenderFns } from "./WhatsApp360.vue?vue&type=template&id=089414f4&scoped=true"
import script from "./WhatsApp360.vue?vue&type=script&lang=js"
export * from "./WhatsApp360.vue?vue&type=script&lang=js"
import style0 from "./WhatsApp360.vue?vue&type=style&index=0&id=089414f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089414f4",
  null
  
)

export default component.exports